import { useEffect, useState, } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import sun from '../assets/img/sun.svg';
import moon from "../assets/img/moon.svg";
import "../styles/header.scss";

const Header = ({ theme, toggleTheme }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // For inner pages, always show scrolled state
  const headerScrolled = isHomePage ? scrolled : true;

  return (
    <header className={`header ${headerScrolled ? "scrolled" : ""}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo">
            <a href="/">
              <img
                src="/image/urja-Logo.png"
                alt="Urjā Logo"
                className="logo-img"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          {/* <nav className="nav">
            <a href="/">Company</a>
            <a href="/">Solutions</a>
            <a href="/">Platform</a>
            <a href="/">Resources</a>
          </nav> */}

          {/* Desktop Actions */}
          <div className="desktop-actions">
            {/* <button className="theme-btn">
              <img src="/image/moon.svg" alt="Theme Toggle" />
            </button> */}

            <button className="theme-btn" onClick={toggleTheme}>
              <img
                src={theme === "dark" ? sun : moon}
                alt="Theme Toggle"
              />
            </button>
            <button className={`btn ${headerScrolled ? "btn-green" : "btn-white"}`}
              onClick={() => navigate("/LeadForm")}
            >
              Book Demo
              <img src="/image/arrow-right.svg" alt="arrow" />
            </button>
          </div>

          {/* Mobile Actions */}
          <div className="actions">
            {/* <button className="theme-btn">
              <img src="/image/moon.svg" alt="Theme Toggle" />
            </button> */}
            <button className="theme-btn" onClick={toggleTheme}>
              <img
                src={theme === "dark" ? sun : moon}
                alt="Theme Toggle"
              />
            </button>
            <button
              className={`menu-btn ${menuOpen ? "active" : ""}`}
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <img src="/image/Menu Icon.svg" alt="Menu" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {menuOpen && (
        <nav className="mobile-nav">
          {/* <a href="/" onClick={() => setMenuOpen(false)}>
            Company
          </a>
          <a href="/" onClick={() => setMenuOpen(false)}>
            Solutions
          </a>
          <a href="/" onClick={() => setMenuOpen(false)}>
            Platform
          </a>
          <a href="/" onClick={() => setMenuOpen(false)}>
            Resources
          </a> */}
          <button className="btn btn-green"
            onClick={() => {
              navigate("/LeadForm");
              setMenuOpen(false);
            }}
          >
            Book Demo
            <img src="/image/arrow-right.svg" alt="arrow" />
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;
